import React from 'react';

import DeleteIcon from '../../assets/icons/DeleteIcon';
import FileCopyIcon from '../../assets/icons/CopyIcon';

import Button from '../shared/Button';

const FlowsActions = ({ onAddClick, onDeleteClick, selectedFlow, deletePermission }) => {
  return (
    <div className='settings-cmp__filters--main'>
      <div className='settings-cmp__actions'>
        <Button
          text={selectedFlow ? 'Add Step' : 'Add Flow'}
          type='submit'
          onClick={onAddClick}
        />

        <Button
          type='icon'
          onClick={onDeleteClick}
          disabled={!deletePermission}
        >
          <DeleteIcon />
        </Button>

        <Button
          type='icon'
        >
          <FileCopyIcon />
        </Button>
      </div>
    </div>
  );
};

export default FlowsActions;
